var render = function render(){var _vm=this,_c=_vm._self._c;return _c('rkm-table',{attrs:{"paginated":"","busy":_vm.busy,"fields":_vm.fields,"items":_vm.items},scopedSlots:_vm._u([{key:"cell(plantonista)",fn:function(row){return [_c('span',{staticClass:"d-block"},[_c('strong',[_vm._v(_vm._s(row.item.cidadaoNome))])]),_c('span',{staticClass:"d-block"},[_vm._v(" "+_vm._s(row.item.ocupacaoCodigoNome)+" ")])]}}])})
}
var staticRenderFns = []

export { render, staticRenderFns }